<!-- Section: Block Content -->
<section>
  <div class="row m-3">
    <div class="col-12 mat-elevation-z8 productos bg-white">
      <div class="card-body">
        <p class="card-text">Ingreso último mes:<span class="text-uppercase badge badge-success ml-2">
            ${{sumaVentasMensual}}</span> <span class="ml-2"></span> Ingresos totales:<span
            class="text-uppercase badge badge-info ml-2">
            ${{sumaVentasTotal}}</span></p>
        <p>
          Filtrar por año:
          <mat-radio-group aria-label="Select an option">
            <mat-radio-button value="2020" (click)="filterYear(2020)">2020</mat-radio-button>
            <mat-radio-button value="2021" (click)="filterYear(2021)" class="ml-2">2021
            </mat-radio-button>
            <mat-radio-button checked="true" value="2022" (click)="filterYear(2022)" class="ml-2">2022
            </mat-radio-button>
          </mat-radio-group>
        </p>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Mes</th>
              <th scope="col">Ingreso</th>
              <th scope="col">Gasto</th>
              <th scope="col">Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let mes of mesesIngreso; index as i">
              <th scope="row"><a class="">{{ month[i] }}</a></th>
              <td class="text-info">{{ mesesIngreso[i] | currency :'$':'symbol':'3.0' }}</td>
              <td class="text-danger">{{ mesesEgreso[i] | currency :'$':'symbol':'3.0' }}</td>
              <td class="pt-2 pb-0 text-success">
                {{ mesesIngreso[i] - mesesEgreso[i] | currency :'$':'symbol':'3.0' }}
                <!-- <canvas id="bar" width="40" height="40"></canvas> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="card-footer white py-3 d-flex justify-content-between">
            </div> -->
    </div>
  </div>
</section>
<!-- Section: Block Content -->